import { useState } from "@";

// Hook for search functionality
export function useSearch(values = {}) {
  const [search, setSearch] = useState({ show: false, values: values });

  const updateSearch = (updates) => {
    setSearch((prevState) => ({
      ...prevState,
      ...updates,
    }));
  };

  return {
    search,
    updateSearch,
  };
}
